<template>
  <div class="Copyright" v-show="hideshow">
    {{ stringList.powered_hospitality_voice }}
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      stringList: "stringList",
    }),
  },
  data() {
    return {
      docmHeight: document.documentElement.clientHeight, //默认屏幕高度
      showHeight: document.documentElement.clientHeight, //实时屏幕高度
      hideshow: true, //显示或者隐藏footer
    };
  },
  mounted() {
    // window.onresize监听页面高度的变化
    window.onresize = () => {
      return (() => {
        this.showHeight = document.body.clientHeight;
      })();
    };
  },
  //监听
  watch: {
    showHeight: function () {
      if (this.docmHeight > this.showHeight) {
        this.hideshow = false;
      } else {
        this.hideshow = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.Copyright {
  position: fixed;
  bottom: 6px;
  left: 50%;
  transform: translateX(-50%);
  width: 287px;
  height: 32px;
  font-family: Arial;
  font-size: 14px;
  text-align: center;
  color: #767676;
  z-index: 0;
}
@media screen and (max-height: 500px) {
  .Copyright {
    display: none;
  }
}
</style>
